export default "__VITE_ASSET__ZWq0qtwH__"